<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            Carousel Web
            <v-btn outlined rounded small color="green" class="ml-2" @click="dialog = true">Agregar</v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-item-group>
            <v-layout row wrap class="pa-3">
              <v-flex v-for="(item, i) in carousel" :key="i" xs12 lg4 sm6 md6>
                <v-item v-slot:default="{ active, toggle }">
                  <v-card class="align-center pa-3 ml-4 mt-3" @click="toggle">
                    <v-layout justify-center>
                      <v-img :src="item" contain>
                        <v-icon
                          color="white"
                          class="iconPlay"
                          @click="delateImage(item)"
                          size="60"
                        >clear</v-icon>
                      </v-img>
                    </v-layout>
                  </v-card>
                </v-item>
              </v-flex>
            </v-layout>
          </v-item-group>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="500">
        <v-card shaped class="rounded-card mx-auto">
          <v-card-title class="headline title">Agregar Imagen</v-card-title>
          <v-card-text>
            <v-layout align-center justify-center column fill-height>
              <v-flex xs2>
                <v-img
                  height="200"
                  class="imgPhoto"
                  @click="pickFile"
                  width="350"
                  v-if="photo"
                  v-bind:src="photo"
                ></v-img>
                <img
                  height="200"
                  class="imgPhoto"
                  src="../../assets/takeImg.png"
                  @click="pickFile"
                  width="350"
                  v-if="!photo"
                />
                <input
                  type="file"
                  style="display:none"
                  ref="image"
                  accept="image/*"
                  @change="onFilePicked"
                />
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red .headline" text @click="closedDialog">Cancelar</v-btn>
            <v-btn color="green" text @click="addImagenDialog()">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data: () => ({
    photo: "",
    dialog: false,
    imageName: "",
    imageFile: "",
    imageUrl: "",
  }),
  mounted() {
    this.loadCarousel();
  },
  computed: mapState({
    carousel: (state) => state.home.carousel,
  }),
  methods: {
    ...mapActions([
      "loadCarousel",
      "addImagen",
      "uploadImage",
      "delateCarousel",
    ]),
    pickFile() {
      this.$refs.image.click();
    },
    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.photo = fr.result;
          this.imageFile = files[0]; // this is an image file that can be sent to server...
        });
        console.log(this.imageFile);
        console.log(this.photo);
      } else {
        this.imageName = "";
        this.imageFile = "";
        this.imageUrl = "";
      }
    },
    closedDialog() {
      this.dialog = false;
      this.photo = "";
    },
    async addImagenDialog() {
      if (this.imageFile) {
        const response = await this.uploadImage({ obj: this.imageFile });
        await this.addImagen({ obj: response });
        if (response) {
          this.loadCarousel();
          this.closedDialog();
          this.$emit("show-snackbar", "Se ha guardado la imagen.");
        } else {
          this.$emit("show-snackbar", "Error al guardar la imagen.");
        }
      }
    },
    async delateImage(item) {
      const response = await this.delateCarousel({ obj: item });
      debugger;
      if (response) {
        this.loadCarousel();
        this.$emit("show-snackbar", "Se ha eliminado la imagen.");
      } else {
        this.$emit("show-snackbar", "Error al eliminar la imagen.");
      }
    },
  },
};
</script>
<style scoped>
.iconPlay {
  position: absolute;
  right: 0;
  margin: auto;
}
.imgPhoto:hover {
  cursor: pointer;
}
.rounded-card {
  border-radius: 20px !important;
}
.v-dialog {
  border-radius: 20px !important ;
}
.title {
  display: flex;
  justify-content: center;
  align-content: center;
}
</style>
